import { render } from "./HeaderTextAdd.vue?vue&type=template&id=5e96e65c"
import script from "./HeaderTextAdd.vue?vue&type=script&lang=js"
export * from "./HeaderTextAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__